import { typedFetch } from "@/lib/helpers";
import { RoomAlertSchedule } from "@/models/room/room.model";
import { RoomNotFoundError } from "../devices/errors/room-not-found.error";
import { API_METHODS } from "../shared";
import { getUpdateRoomSettingsAlertSchedulesUrl } from "./api-url.constants";
import { ROOM_NOT_FOUND_ERROR, UpdateRoomError, UpdateRoomErpIntegrationsError } from "./errors";
import {
  UPDATE_ROOM_ERROR_MESSAGE,
  UPDATE_ROOM_ERP_INTEGRATIONS_ERROR_MESSAGE,
} from "./errors/error-message.constants";

export interface UpdateRoomSettingsAlarmSchedulesApiDto {
  _id: string;
  alertSchedules: RoomAlertSchedule[];
}

export const updateRoomSettingsAlarmSchedules = async (
  bodyDTO: UpdateRoomSettingsAlarmSchedulesApiDto
): Promise<boolean> => {
  const { _id, ...body } = bodyDTO;
  const result = await typedFetch(getUpdateRoomSettingsAlertSchedulesUrl(_id), {
    method: API_METHODS.PUT,
    body: JSON.stringify(body),
  });

  if (result.ok) return true;

  const responseJson = await result.json();
  if ("error" in responseJson) {
    const message = Array.isArray(responseJson.message)
      ? responseJson.message[0]
      : responseJson.message;
    if (message === UPDATE_ROOM_ERP_INTEGRATIONS_ERROR_MESSAGE)
      throw new UpdateRoomErpIntegrationsError();
    if (message === UPDATE_ROOM_ERROR_MESSAGE) throw new UpdateRoomError();
    if (message === ROOM_NOT_FOUND_ERROR) throw new RoomNotFoundError();
    throw new Error(message);
  }

  return true;
};
